export default __webpack_public_path__ + "774bcba0be880d58c05780b71b2fbe8d.svg";